<template>
  <OrderDetailPayment
    :orderAmount="orderAmount"
    :deliveryTip="deliveryTip"
    :discountAmount="discountAmount"
    :baeminPoint="baeminPoint"
    :orderDetailDiscounts="orderDetailDiscounts"
    :orderDetailPayment="orderDetailPayment"
  />
</template>

<script>
import OrderDetailPayment from '../../layouts/organisms/OrderDetailPayment/index'

export default {
  name: 'OrderDetailPaymentContainer',
  components: { OrderDetailPayment },
  computed: {
    isSign() {
      return this.$store.getters.isSign
    },
    orderAmount() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].summary.orderAmount
    },
    deliveryTip() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].delivery.deliveryTip
    },
    discountAmount() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].discountAmount
    },
    orderDetailDiscounts() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].discounts
    },
    orderDetailPayment() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].payment
    },
    baeminPoint() {
      return this.$store.getters['myOrderHistoryDetailV2/orderDetail'].point
    }
  }
}
</script>
